import { Outlet } from 'react-router';

export { loader } from './root-loader';

function App() {
  return <Outlet />;
}

export default App;
